<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="featureEdit" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="父级分类" prop="SysFeature.parentId">
            <el-cascader class="input-item" v-model="featureEdit.parentId.value" :options="featureEdit.parentId.impl.dropdownList" filterable
              :clearable="true" :show-all-levels="false" placeholder="请选择父级分类"
              :props="{value: 'id', label: 'name', checkStrictly: true}"
              @visible-change="featureEdit.parentId.impl.onVisibleChange"
              @change="onParentIdValueChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="标签名称" prop="SysFeature.featureName">
            <el-input class="input-item" v-model="formData.SysFeature.featureName"
              :clearable="true" placeholder="标签名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="显示顺序" prop="SysFeature.showOrder">
            <el-input class="input-item" v-model="formData.SysFeature.showOrder"
              :clearable="true" placeholder="显示顺序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('featureEdit:featureEdit:add')"
              @click="onAddClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              关闭
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysFeatureController, DictionaryController } from '@/api';

export default {
  name: 'featureEdit',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysFeature: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          parentId: undefined,
          featureCode: undefined,
          featureName: undefined,
          featureStatus: undefined,
          showOrder: undefined,
          lenovoWord: undefined,
          isDatasourceInit: false
        }
      },
      featureEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        parentId: {
          impl: new DropdownWidget(this.loadParentIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 父级分类下拉数据获取函数
     */
    loadParentIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictFeatureDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 父级分类选中值改变
     */
    onParentIdValueChange (value) {
      this.formData.SysFeature.parentId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 更新标签词编辑
     */
    refreshFeatureEdit (reloadData = false) {
      this.loadSysFeatureData().then(res => {
        if (!this.featureEdit.isInit) {
          // 初始化下拉数据
          this.featureEdit.parentId.impl.onVisibleChange(true).then(res => {
            this.featureEdit.parentId.value = findTreeNodePath(res, this.formData.SysFeature.parentId, 'id');
          }).catch(e => {});
        }
        this.featureEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.featureEdit.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            parentIdDictMap: findTreeNode(this.featureEdit.parentId.impl.dropdownList, this.formData.SysFeature.parentId, 'id'),
            ...this.formData.SysFeature
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          sysFeatureDto: {
            id: this.id,
            orgCode: this.formData.SysFeature.orgCode,
            parentId: this.formData.SysFeature.parentId,
            featureCode: this.formData.SysFeature.featureCode,
            featureName: this.formData.SysFeature.featureName,
            featureStatus: this.formData.SysFeature.featureStatus,
            showOrder: this.formData.SysFeature.showOrder,
            lenovoWord: this.formData.SysFeature.lenovoWord
          }
        };
        if (this.id == null) {
          SysFeatureController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          SysFeatureController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    /**
     * 获取系统标签词表详细信息
     */
    loadSysFeatureData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SysFeature.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SysFeatureController.view(this, params).then(res => {
            this.formData.SysFeature = {...res.data, isDatasourceInit: true};
            if (this.formData.SysFeature.parentIdDictMap && this.featureEdit.parentId.impl.dirty) {
              this.featureEdit.parentId.impl.dropdownList = [this.formData.SysFeature.parentIdDictMap];
            }
            if (this.formData.SysFeature.parentId) this.featureEdit.parentId.value = [this.formData.SysFeature.parentId];
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SysFeature.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysFeature: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          parentId: undefined,
          featureCode: undefined,
          featureName: undefined,
          featureStatus: undefined,
          showOrder: undefined,
          lenovoWord: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshFeatureEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysFeature = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
